import {ReactComponent as Layer1} from "../assets/icons/Layer_24.svg";
import {ReactComponent as Layer2} from "../assets/icons/Layer_strategies.svg";
import {ReactComponent as Layer3} from "../assets/icons/Layer_phone.svg";
import {ReactComponent as Layer4} from "../assets/icons/Layer_tools.svg";

const TopicsInfo = [
    {title: 'Bitcoin', icon: 'bitcoin.svg'},
    {title: 'Ethereum', icon: 'ethereum.svg'},
    {title: 'Trade', icon: 'trade.svg'},
    {title: 'Analysis', icon: 'analysis.svg'},
    {title: 'Wallets', icon: 'wallet.svg'},
    {title: 'Security', icon: 'security.svg'},
    {title: 'Airdrops', icon: 'airdrops.svg'},
    {title: 'Web 3.0', icon: 'web.svg'},
]
const Exchanges = [
    {
        id: 1,
        imgUrl: '/images/binance.svg'
    },
    {
        id: 2,
        imgUrl: '/images/Bybit.svg'
    },
    {
        id: 3,
        imgUrl: '/images/bitget.svg'
    },
    {
        id: 4,
        imgUrl: '/images/gate.svg'
    },
    {
        id: 5,
        imgUrl: '/images/htx.svg'
    },
    {
        id: 6,
        imgUrl: '/images/kucoin.svg'
    },
    {
        id: 7,
        imgUrl: '/images/mexc.svg'
    },
    {
        id: 8,
        imgUrl: '/images/okx.svg'
    },
    {
        id: 9,
        imgUrl: '/images/xt.svg'
    },

]
const TutorialsCategories = [
    {
        id: 1,
        title: 'Category 1',
    },
    {
        id: 2,
        title: 'Category 2',
    },
    {
        id: 3,
        title: 'Category 3',
    },
    {
        id: 4,
        title: 'Category 4',
    },
    {
        id: 5,
        title: 'Category 5',
    },
    {
        id: 6,
        title: 'Category 6',
    },
]
const TutorialsData = [
    {
        id: 1,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        category: [1, 2],
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 2,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        category: [1, 6],
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 3,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        category: [3, 5],
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 4,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        category: [2, 4],
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 5,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        category: [1, 6],
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 6,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        category: [3],
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 7,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 8,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
    {
        id: 9,
        title: 'Cryptocurrency Arbitrage Strategies. Risk-Free Strategy',
        lesson: [
            {
                id: 1,
                number: '1',
                title: 'How To Read A Cryptocurrency Chart...',
                text: 'Risk-free cryptocurrency arbitrage strategy tailored for those with a starting capital of $500 or more! In this guide, discover how to choose long-term coins, conduct classic arbitrage without withdrawals, and ensure profitable trades in 3-5 seconds. Follow our step-by-step example with the Hedra coin and learn essential tips like checking order volumes and avoiding trades for more than 25% of the orders. Stay informed about investment risks, invest in verified projects, and explore more strategies on our blog. Subscribe to our social networks, ask questions, or request a test day from our dedicated support team today!' +
                    'Risk-free cryptocurrency arbitrage strategy tailored for those with a starting capital of $500 or more! In this guide, discover how to choose long-term coins, conduct classic arbitrage without withdrawals, and ensure profitable trades in 3-5 seconds. Follow our step-by-step example with the Hedra coin and learn essential tips like checking order volumes and avoiding trades for more than 25% of the orders. Stay informed about investment risks, invest in verified projects, and explore more strategies on our blog. Subscribe to our social networks, ask questions, or request a test day from our dedicated support team today!' +
                    'Risk-free cryptocurrency arbitrage strategy tailored for those with a starting capital of $500 or more! In this guide, discover how to choose long-term coins, conduct classic arbitrage without withdrawals, and ensure profitable trades in 3-5 seconds. Follow our step-by-step example with the Hedra coin and learn essential tips like checking order volumes and avoiding trades for more than 25% of the orders. Stay informed about investment risks, invest in verified projects, and explore more strategies on our blog. Subscribe to our social networks, ask questions, or request a test day from our dedicated support team today!',
                imgUrl: 'financical_report.jpg',
                url: true,
            },
            {
                id: 2,
                number: '2',
                title: 'Why Is Technical Analysis Uniquely Suited To Cryptocurrency Like Bitcoin...',
                url: false,
            },
            {
                id: 3,
                number: '3',
                title: 'Fundamental Investing And Technical Analysis With Cryptocurrency...',
                url: false,
            }
        ],

    },
]
const Blogs = [
    {
        id: 1,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
    {
        id: 2,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
    {
        id: 3,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
    {
        id: 4,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
    {
        id: 5,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
    {
        id: 6,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
    {
        id: 7,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
    {
        id: 8,
        title: 'Why is Bitcoin price up today?',
        description: "The Bitcoin price is trading near its highest levels in a month following back-to-back dovish updates from central banks in the United States and Japan.",
        tags: ["#Announcements"],
        link: 'slug',
        imgUrl: 'financical_report.jpg',
        createdAt: '09 Sep, 2024'
    },
]
const Screener = [
    {
        id: 1,
        selling: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        buying: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        notification: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ]
    },
    {
        id: 2,
        selling: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        buying: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        notification: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ]
    },
    {
        id: 3,
        selling: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        buying: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        notification: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ]
    },
    {
        id: 4,
        selling: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        buying: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
        notification: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ]
    }
];
const ScreenerTemplates = [
    {
        id: 1,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 2,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 3,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 4,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 5,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 6,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 7,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 8,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 9,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
    {
        id: 10,
        title: 'TOP300 Coins',
        description: 'Popular 300 crypto coins',
        type: 'public'
    },
];
const SpotScreener = [
    {
        id: 1,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 2,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 3,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 4,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 5,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 6,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 7,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 8,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 9,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 10,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 11,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 12,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    },
    {
        id: 13,
        exchange: 'BitGet',
        coin: 'Bitcoin',
        pair: 'BTC/USDT',
        sellPrice: "$0.10282",
        lifeTime: "8m 44s",
        volume: "41.04M",
        volumePrice: "$312.14",
        buy: "$0.10282",
        profit: "+4.91%",
        networksWithdrawal: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        networksDeposit: ["Ethereum, BNB, Mantra, Ethereum, Aptos"],
        hedging: ["blofin, Bybon, Gate, blofin, Crypto.com, blofin, blofin"],
    }
];
const MenuNotif = [
    {
        id: 1,
        title: 'Margin Call Alert',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Your account’s margin level has dropped below the required threshold of 30%, and you are at risk of liquidation. To maintain your open positions, please add funds to your account or reduce your exposure. Failure to do so may result in automatic liquidation of your positions to cover the shortfall.',
    },
    {
        id: 2,
        title: 'System Downtime Alert',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience. Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience.',
    },
    {
        id: 3,
        title: 'New Login Request Detected',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'We\'ve detected a new login request from an unrecognized device or location. If this was you, no action is needed. If you did not attempt to log in, please secure your account by changing your password and contacting our support team immediately.',
    },
    {
        id: 4,
        title: 'Referral Bonus Earned',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Congratulations! You\'ve earned a referral bonus. Thank you for inviting your friends! Check your account balance for the updated amount',
    },
    {
        id: 5,
        title: 'Transaction Confirmed',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Your Bitcoin transaction of 0.5 BTC has been successfully confirmed. you can see full detail on history page.',
    },
    {
        id: 6,
        title: 'Margin Call Alert',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Your account’s margin level has dropped below the required threshold of 30%, and you are at risk of liquidation. To maintain your open positions, please add funds to your account or reduce your exposure. Failure to do so may result in automatic liquidation of your positions to cover the shortfall.',
    },
    {
        id: 7,
        title: 'System Downtime Alert',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience. Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience.',
    },
    {
        id: 8,
        title: 'New Login Request Detected',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'We\'ve detected a new login request from an unrecognized device or location. If this was you, no action is needed. If you did not attempt to log in, please secure your account by changing your password and contacting our support team immediately.',
    },
    {
        id: 9,
        title: 'Referral Bonus Earned',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Congratulations! You\'ve earned a referral bonus. Thank you for inviting your friends! Check your account balance for the updated amount',
    },
    {
        id: 10,
        title: 'Transaction Confirmed',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Your Bitcoin transaction of 0.5 BTC has been successfully confirmed. you can see full detail on history page.',
    },
    {
        id: 11,
        title: 'Margin Call Alert',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Your account’s margin level has dropped below the required threshold of 30%, and you are at risk of liquidation. To maintain your open positions, please add funds to your account or reduce your exposure. Failure to do so may result in automatic liquidation of your positions to cover the shortfall.',
    },
    {
        id: 12,
        title: 'System Downtime Alert',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience. Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience.',
    },
    {
        id: 13,
        title: 'New Login Request Detected',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'We\'ve detected a new login request from an unrecognized device or location. If this was you, no action is needed. If you did not attempt to log in, please secure your account by changing your password and contacting our support team immediately.',
    },
    {
        id: 14,
        title: 'Referral Bonus Earned',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Congratulations! You\'ve earned a referral bonus. Thank you for inviting your friends! Check your account balance for the updated amount',
    },
    {
        id: 15,
        title: 'Transaction Confirmed',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Your Bitcoin transaction of 0.5 BTC has been successfully confirmed. you can see full detail on history page.',
    },
    {
        id: 16,
        title: 'Margin Call Alert',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Your account’s margin level has dropped below the required threshold of 30%, and you are at risk of liquidation. To maintain your open positions, please add funds to your account or reduce your exposure. Failure to do so may result in automatic liquidation of your positions to cover the shortfall.',
    },
    {
        id: 17,
        title: 'System Downtime Alert',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience. Our platform will be temporarily unavailable due to unexpected server issues. We are working to restore services as quickly as possible. Thank you for your patience.',
    },
    {
        id: 18,
        title: 'New Login Request Detected',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'We\'ve detected a new login request from an unrecognized device or location. If this was you, no action is needed. If you did not attempt to log in, please secure your account by changing your password and contacting our support team immediately.',
    },
    {
        id: 19,
        title: 'Referral Bonus Earned',
        date: '2021-03-10 - 20:19:15',
        status: 0,
        text: 'Congratulations! You\'ve earned a referral bonus. Thank you for inviting your friends! Check your account balance for the updated amount',
    },
    {
        id: 20,
        title: 'Transaction Confirmed',
        date: '2021-03-10 - 20:19:15',
        status: 1,
        text: 'Your Bitcoin transaction of 0.5 BTC has been successfully confirmed. you can see full detail on history page.',
    },
]
const BlogTags = [
    {id: 1, title: '#Announcements', checked: false},
    {id: 2, title: '#Events', checked: false},
    {id: 3, title: '#Partnerships', checked: false},
    {id: 4, title: '#News', checked: false},
];
const NotifTemplates = [
    {
        id: '1',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '2',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '3',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '4',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '5',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '6',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '7',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '8',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '9',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
    {
        id: '10',
        name: 'name',
        tags: [
            {
                id: 1,
                title: 'volume',
            },
            {
                id: 2,
                title: 'profitIndexMin',
            },
            {
                id: 3,
                title: 'sellPriceAvg',
            },
            {
                id: 4,
                title: 'profitIndexAvg',
            },
            {
                id: 5,
                title: 'profitIndexAvg',
            },
            {
                id: 6,
                title: 'profitIndexAvg',
            },
            {
                id: 7,
                title: 'minConfirm',
            },
            {
                id: 8,
                title: 'minConfirm',
            },
            {
                id: 9,
                title: 'minConfirm',
            },
            {
                id: 10,
                title: 'volume',
            },
            {
                id: 11,
                title: 'profitIndexAvg',
            },
            {
                id: 12,
                title: 'profitIndexAvg',
            }
        ],
    },
]
const userInfo = {
    uuid: 'asd213a4d565a4sd6a',
    avatar: 'https://bit.ly/dan-abramov',
    firstName: 'John',
    lastName: 'Doe',
    email: 'John-Doe@gmail.com',
    promocode: 'a4dvz315a6',
    phone: '(555) 123-4567',
    region: 'Germany',
    country: {
        label: '374',
        value: '374',
        flag: `https://flagcdn.com/w40/am.png`,
        code: '374',
    },
    telegramNic: '@2132dfsdfv',
}

const referalData = [
    {
        id: 1,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 2,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 3,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 4,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 5,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Sell',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Cancelled'
    },
    {
        id: 6,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 7,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Cancelled'
    },
    {
        id: 8,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 9,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 10,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Cancelled'
    },
    {
        id: 11,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 12,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 13,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 14,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 15,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 16,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 17,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 18,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 19,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 20,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 21,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 22,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 23,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 24,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 25,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 26,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
    {
        id: 27,
        date: '13/03/24-20:54:29',
        price: '$56.87',
        pair: 'BTC/USDT',
        pair_type: 'Bitcoin',
        type: 'Buy',
        total_price: '$56.87',
        amount: '0.2',
        executed: '0.2',
        status: 'Completed'
    },
];

const earlyAccessPageHighlights = [
    {
        title: '24/7 Tracking of 20+ Exchanges',
        description: 'Our advanced algorithms scan all crypto pairs across 20+ leading exchanges, analyzing thousands of spreads daily to keep you ahead of the game',
        icon: <Layer1/>,
    },
    {
        title: 'Strategies and Tutorials to Maximize Your Profit',
        description: 'Gain access to expert strategies and tutorials that help you make smarter trading decisions and maximize your returns.',
        icon: <Layer2/>,
    },
    {
        title: 'Telegram Notification Bot',
        description: 'Never miss a trading opportunity with our Telegram bot that keeps you informed 24/7',
        icon: <Layer3/>,
    },
    {
        title: 'Weekly Tool Unlocks',
        description: 'Gain exclusive priority access to our newest tools before they’re publicly available. Each week, a new feature will be unlocked during the Early Access campaign',
        icon: <Layer4/>,
    },
];

const comments_data = [
    {
        username: "sara joan",
        user_avatar: "x_icon.svg",
        user_type: "Community Member",
        comment: 'The platform is incredibly user-friendly, and since I became a holder, I\'ve seen a significant increase in my assets. It\'s great to be part of a project where everything just works smoothly! I’ve been impressed by the continuous innovation and dedication of the team. As a holder, I feel like I\'m part of something truly groundbreaking, and I can’t wait to see where this project goes next.'
    },
    {
        username: "sara joan",
        user_type: "Community Member",
        user_avatar: "x_icon.svg",
        comment: 'The platform is incredibly user-friendly, and since I became a holder, I\'ve seen a significant increase in my assets. It\'s great to be part of a project where everything just works smoothly! I’ve been impressed by the continuous innovation and dedication of the team. As a holder, I feel like I\'m part of something truly groundbreaking, and I can’t wait to see where this project goes next.'
    },
    {
        username: "sara joan",
        user_type: "Community Member",
        user_avatar: "x_icon.svg",
        comment: 'The platform is incredibly user-friendly, and since I became a holder, I\'ve seen a significant increase in my assets. It\'s great to be part of a project where everything just works smoothly! I’ve been impressed by the continuous innovation and dedication of the team. As a holder, I feel like I\'m part of something truly groundbreaking, and I can’t wait to see where this project goes next.'
    },
    {
        username: "sara joan",
        user_type: "Community Member",
        user_avatar: "x_icon.svg",
        comment: 'The platform is incredibly user-friendly, and since I became a holder, I\'ve seen a significant increase in my assets. It\'s great to be part of a project where everything just works smoothly! I’ve been impressed by the continuous innovation and dedication of the team. As a holder, I feel like I\'m part of something truly groundbreaking, and I can’t wait to see where this project goes next.'
    },
    {
        username: "sara joan",
        user_type: "Community Member",
        user_avatar: "x_icon.svg",
        comment: 'The platform is incredibly user-friendly, and since I became a holder, I\'ve seen a significant increase in my assets. It\'s great to be part of a project where everything just works smoothly! I’ve been impressed by the continuous innovation and dedication of the team. As a holder, I feel like I\'m part of something truly groundbreaking, and I can’t wait to see where this project goes next.'
    },
];

const faq_questions = [
    {
        title: 'What happens after Early Access ends?',
        description: 'Early Access provides full functionality of the CEX Scanner and priority access to future tools. Some premium tools will unlock progressively.',
    },
    {
        title: 'How does the referral program work?',
        description: 'Early Access provides full functionality of the CEX Scanner and priority access to future tools. Some premium tools will unlock progressively.',
    },
    {
        title: 'Are there any limitations during Early Access?',
        description: 'Early Access provides full functionality of the CEX Scanner and priority access to future tools. Some premium tools will unlock progressively.',
    },
];

const cards_info = [
    {
        id: 1,
        imgUrl: '/images/tools_in_one.png',
        title: 'All Tools in One',
        description: 'CEX Arbitrage Scanner'
    },
    {
        id: 2,
        imgUrl: '/images/tutorials.png',
        title: 'Strategies & Tutorials',
        description: 'Learn expert techniques for better trades'
    },
    {
        id: 3,
        imgUrl: '/images/referal_program.png',
        title: 'Referral Program',
        description: 'Invite users and earn commissions'
    },
    {
        id: 4,
        imgUrl: '/images/artwork.png',
        title: '24/7 Notifications',
        description: 'CEX Arbitrage Scanner'
    },
];

export {
    TopicsInfo,
    userInfo,
    referalData,
    earlyAccessPageHighlights,
    comments_data,
    faq_questions,
    cards_info,
    Blogs,
    BlogTags,
    SpotScreener,
    TutorialsCategories,
    TutorialsData,
    ScreenerTemplates,
    Screener,
    NotifTemplates,
    MenuNotif,
    Exchanges,
}